import { setDiagramDecompositionTree as setDiagramDecompositionTreeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    source?: String,
}

export const setDiagramDecompositionTree = ({
    source,
    eventEmitter,
}: Props) => {
    setDiagramDecompositionTreeDiagram(source);
    eventEmitter.emit(Event.setDiagramDecompositionTree);
  
};
